<div class="row">
  <div class="col-12">
    <button (click)="exportFile('EXCEL')" class="btn btn-primary float-right" type="button" name="" value="">
      <span><i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Excel</span>
    </button>
  </div>
</div>
